import { Alert, Button, Col, Divider, Empty, List, Row, Select, Space, Spin, Table } from 'antd';
import { SyncOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { CompanyProductVersionModel, Feature } from '../../models/product-interface';
import Search from 'antd/lib/input/Search';
import { Link } from 'react-router-dom';
import { Company } from '../../models/company-interface';

const { Option } = Select;

interface CompanyFeaturesTabProps {
  products: CompanyProductVersionModel[] | undefined;
  company: Company | undefined;
  demoFeatures: Feature[] | undefined;
  demoCompany: boolean;
  isLoading: boolean;
}

interface CompanyFeature {
    id: number;
    name: string;
    products: CompanyProductVersionModel[];
    isOnDemo: boolean;
    allowLimit: boolean;
    recordLimit: number;
}

export function CompanyFeaturesTab({ products, company, isLoading, demoFeatures, demoCompany }: CompanyFeaturesTabProps) {

  const [searchText,setSearchText] = useState<string>(null)
  const [filteredFeatures,setFilteredFeatures] = useState<CompanyFeature[]>(null)

  useEffect(() => {
    var data = allFeatures()
    if(!!searchText && searchText.length > 0) {
      let text = searchText.toLowerCase()
      data = data.filter(x => x.name.toLowerCase().includes(text))
    }

    setFilteredFeatures(data)
  },[searchText,products,demoFeatures,company])

  const allFeatures = () => {
    var features:Feature[] = []
    products?.forEach(p => {
        p.features.forEach(pf => {
            if(!features.some(f => f.id == pf.id)) {
                features.push(pf)
            } else {
                var existing = features.find(f => f.id == pf.id)
                
                if(existing.recordLimit > 0 && (pf.recordLimit == 0 || pf.recordLimit > existing.recordLimit)) {
                    if(pf.recordLimit !== 0 && existing.recordLimit !== 0) {
                        existing.recordLimit = existing.recordLimit + pf.recordLimit
                    } else {
                        existing.recordLimit = pf.recordLimit
                    }
                }
            }
        })
    })

    if(!!demoFeatures && demoCompany) {
      demoFeatures.forEach(pf => {
        if(!features.some(f => f.id == pf.id)) {
          features.push(pf)
        } else {
            var existing = features.find(f => f.id == pf.id)
            
            if(existing.recordLimit > 0 && (pf.recordLimit == 0 || pf.recordLimit > existing.recordLimit)) {
                if(pf.recordLimit !== 0 && existing.recordLimit !== 0) {
                    existing.recordLimit = existing.recordLimit + pf.recordLimit
                } else {
                    existing.recordLimit = pf.recordLimit
                }
            }
        }
      })
    }

    return features.map(x => {
        var cf:CompanyFeature = {
            id: x.id,
            name: x.name,
            products: products?.filter(p => p.features.some(f => f.id === x.id)),
            isOnDemo: demoFeatures?.some(df => df.id == x.id),
            allowLimit: x.allowLimit,
            recordLimit: x.recordLimit
        }
        return cf
    }) 
  }

  
  const columns: any = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (name: string, record: CompanyFeature) => {
        return (name
        )
      },
      sorter: {
        compare: (a: CompanyFeature, b: CompanyFeature) =>
          a.name.localeCompare(b.name)
      },
    },
    {
      title: 'Products',
      dataIndex: 'products',
      key: 'products',
      render: (products: CompanyProductVersionModel[] | undefined, record: CompanyFeature) => {
        return (<Row>
            {products?.map(p => <Col span={24}><Link to={`/admin/products/${p.product.id}`}>{p.product.name}</Link> v{p.versionId}</Col>)}
            {(company?.isDemoCompany ?? false) && demoFeatures.some(x => x.id == record.id) && <Col span={24}><Link to={`/admin/products/demo`}>Demo Company</Link></Col> }
        </Row>
        )
      },
    },
    {
      title: 'Record Limit',
      dataIndex: 'recordLimit',
      key: 'recordLimit',
      render: (recordLimit: number, record: Feature) => {
        return (recordLimit > 0 ? recordLimit : record.allowLimit ? "Unlimited" : ""
        )
      },
      sorter: {
        compare: (a: Feature, b: Feature) =>
          a.recordLimit == b.recordLimit ? 0 : a.recordLimit > b.recordLimit ? -1 : 1
      },
    },
  ];

  

  return (
    <Spin spinning={isLoading}>
      <Alert
        type='info'
        message={
          <>
            The following list shows all features assigned to this company from all of the products within their subscription. Record limits reflected here are combined and may not represent the limit from a particular product. For more detail, view the products tab.
          </>
        }
      />
      <Alert type="info" showIcon message="This list indicates if a company has a feature, but not if they have such feature enabled!" style={{marginTop: 10}}/>
      <br/>
      
      <Row justify='end'>
            <Col>
            <Space>
              <Search placeholder='Filter by feature name' onChange={(e) => setSearchText(e.target.value)} allowClear style={{width: 400}}/>
            </Space>
            </Col>
      </Row><br/>
      <Table
            columns={columns}
            size="small"
            dataSource={filteredFeatures ?? allFeatures()}
            locale={{
            emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={`No features`} />
            }}
            scroll={{ x: 715 }}
            pagination={{defaultPageSize: 50, showTotal: (total,range) => `${range[0]}-${range[1]} of ${total} feature${total !== 1 ? "s" : ""}` }}
        />
    </Spin>
  );
}

